import { Spinner } from 'react-bootstrap';
export function LoadingSpinner() {
  return <div className="d-flex justify-content-center align-items-center py-5" data-sentry-component="LoadingSpinner" data-sentry-source-file="LoadingSpinner.tsx">
            {/* spinner-border draws with currentColor — plain black, not a
                Bootstrap variant ($primary was never overridden, so
                variant="primary" rendered stock-Bootstrap blue). */}
            <Spinner animation="border" style={{
      color: '#000'
    }} data-sentry-element="Spinner" data-sentry-source-file="LoadingSpinner.tsx" />
        </div>;
}